<template>
  <div>
    <div class="header bg-secondary py-7 py-lg-8 pt-lg-9">
      <b-container>
        <div class="header-body text-center mb-7">
          <b-row class="justify-content-center">
            <b-col xl="5" lg="6" md="8" class="px-5">
              <h1 class="display-2 " style="white-space: nowrap;">
                 Lili.Monitor Demo
              </h1>
              <h1 class="text-gray-dark font-weight-bold">Welcome Back!</h1>
              <p class="text-lead text-gray-dark font-weight-bold">Sign In to Access Your Monitoring Interface</p>
            </b-col>
          </b-row>
        </div>
      </b-container>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1"
          xmlns="http://www.w3.org/2000/svg">
          <polygon class="fill-default" points="2560 0 2560 100 0 100"></polygon>
        </svg>
      </div>
    </div>

    <b-container class="mt--8 pb-5">
      <b-row class="justify-content-center">
        <b-col lg="5" md="7">
          <b-card no-body class="bg-white shadow-sm mb-0">
            <b-card-body class="px-lg-5 py-lg-5">
              <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
                <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
                  <base-input alternative class="mb-3" name="Email" :rules="{ required: true, email: true }"
                    prepend-icon="ni ni-email-83" placeholder="Email" v-model="model.email">
                  </base-input>

                  <base-input alternative class="mb-3" name="Password" :rules="{ required: true, min: 6 }"
                    prepend-icon="ni ni-lock-circle-open" type="password" placeholder="Password"
                    v-model="model.password">
                  </base-input>

                  <b-alert variant="danger" :show="!!error" dismissible @dismissed="error = null">
                    {{ error }}
                  </b-alert>

                  <div class="text-center">
                    <base-button type="primary" native-type="submit" class="my-4" :disabled="loading">
                      {{ loading ? 'Signing in...' : 'Sign in' }}
                    </base-button>
                  </div>
                </b-form>
              </validation-observer>
            </b-card-body>
          </b-card>
          <b-row class="mt-3">
            <b-col cols="12" class="text-center">
              <router-link to="/dashboard" class="text-light">
                <small>Forgot password?</small>
              </router-link>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Papa from 'papaparse';
export default {
  name: 'SignIn',
  data() {
    return {
      model: {
        email: '',
        password: ''
      },
      loading: false,
      error: null
    };
  },
  methods: {
    async onSubmit() {
      this.loading = true;
      this.error = null;

      try {
        const response = await fetch(
          "https://docs.google.com/spreadsheets/d/1bRh8P-Fb_0mOzK2ElFe2vrwrwXFdTexZ/gviz/tq?tqx=out:csv&gid=203150660"
        );
        const csvText = await response.text();

        const parsedData = Papa.parse(csvText, { header: true }).data;

        const users = parsedData.filter(user => user.email && user.password);

        const user = users.find(
          (u) =>
            u.email.trim().toLowerCase() === this.model.email.trim().toLowerCase() &&
            u.password.trim() === this.model.password.trim()
        );

        if (user) {
          this.$auth.setUser({
            id: user.id,
            email: user.email,
            name: user.name,
          });
          this.$router.push("/#");
        } else {
          this.error = "Invalid email or password";
        }
      } catch (err) {
        this.error = "An error occurred. Please try again.";
      } finally {
        this.loading = false;
      }
    },
  }
};
</script>
